import { memo } from 'react';
import { ReviewTotals } from '@/lib/yotpo';
import { Entry } from 'contentful';
import { ExtendedProductFields } from '@/core/contentfulConfig';

export interface ReviewsSchemaProps {
  totals?: ReviewTotals;
  product?: Entry<ExtendedProductFields>;
}

const ReviewsSchema = ({ totals, product }: ReviewsSchemaProps) => {
  return (
    <span
      itemProp="aggregateRating"
      itemScope
      itemType="http://schema.org/AggregateRating"
      className="sr-only"
    >
      <span itemProp="itemReviewed">{product?.fields.title}</span>
      <span itemProp="ratingValue">{totals?.average_score ?? 0}</span>
      <span itemProp="reviewCount">{totals?.total_review ?? 0}</span>
    </span>
  );
};

export default memo(ReviewsSchema);
